import { createContext, useContext } from "react";
const AwaitContext = createContext(null);
export function useAwaitContext() {
    const ctx = useContext(AwaitContext);
    if (!ctx) {
        return {
            isAwaiting: false,
        };
    }
    return ctx;
}
export { AwaitContext };
